import { Box, Button, Typography, useTheme } from "@mui/material";
import { useKeycloak } from "@react-keycloak/web";
import {
  type MRT_ColumnDef,
} from "material-react-table";
import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useGetInvoices } from "../../../../tanstackQuery/queries/superAdmin/invoice";
import { AdminGlobalTable } from "../../../tables/AdminGlobalTable";
import Loader from "../../common/Loader";
import CreateInvoiceModal from "./CreateInvoiceModal";
import { useQueryClient } from "@tanstack/react-query";

type invoiceLicense = {
  no: string;
  license: string;
  project: string;
  status: string;
  available: number;
  total: number;
  date: string;
};

const invoiceLicenseCol: MRT_ColumnDef<invoiceLicense>[] = [
  { 
    header: "Product", 
    accessorKey: "productName",
    Cell: (cell) => {
      return (
        <Typography fontSize="15px">{cell.row.original?.product?.productName}</Typography>
      );
    }
  },
  { header: "Name", accessorKey: "name" },
  { header: "Project", accessorKey: "project" },
  { header: "Origin", accessorKey: "type" },
  { header: "Status", accessorKey: "status" },
  {
    header: "Used Quantity",
    accessorKey: "usedQuantity",
    Cell: (cell) => {
      return (
        <Typography fontSize="15px">{cell.row.original?.product?.usedQuantity}</Typography>
      );
    }
  },
  {
    header: "Total Quantity",
    accessorKey: "quantity",
    Cell: (cell) => {
      return (
        <Typography fontSize="15px">{cell.row.original?.product?.quantity}</Typography>
      );
    }
  },
];

const InvoiceAndLicenseInfoTable = () => {
  const theme = useTheme();
  const { orgID } = useParams();
  const client = useQueryClient();

  const [openInvoiceModal, setOpenInvoiceModal] = useState(false);
  const handleOpenInvoiceModal = () => setOpenInvoiceModal(true);
  const handleCloseInvoiceModal = () => setOpenInvoiceModal(false);

  const invoicesData = client.getQueryData(["get-invoices",{ orgID }]);

  const columns = useMemo<MRT_ColumnDef<invoiceLicense>[]>(() => invoiceLicenseCol, [] );

  return (
    <>
      <CreateInvoiceModal
        open={openInvoiceModal}
        handleClose={handleCloseInvoiceModal}
      />

      <AdminGlobalTable
        columns={columns}
        data={invoicesData}
        config={{
          muiSelectCheckboxProps: { color: "secondary" },
          muiTableContainerProps: {
            sx: {
              maxHeight: "calc(100vh - 590px)",
              minHeight: "calc(100vh - 590px)",
            },
          },
          muiTableBodyRowProps: () => ({
            hover: false,
            sx: {
              backgroundColor: "transparent",
              ":hover": { backgroundColor: theme.custom.hoverOptionColor },
            },
          }),
          renderTopToolbarCustomActions: ({ table }) => (
            <Box
              sx={{
                display: "flex",
                gap: "16px",
                padding: "8px",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{ fontSize: "16px", color: "#626262", padding: "8px" }}
              >
                Invoice & License
              </Typography>
              <Button
                size="small"
                variant="outlined"
                onClick={handleOpenInvoiceModal}
              >
                Create Invoice
              </Button>
            </Box>
          ),
        }}
      />
    </>
  );
};

export default InvoiceAndLicenseInfoTable;
